import * as React from 'react';
import { useEffect, useState } from 'react';
import { Grid } from "@mui/material"
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import { useNavigate } from 'react-router-dom';
import img01 from "../../assets/images/img01.jpg";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import api from "../../utils/api";
import * as util from "../../utils/util";
// import tabbg from "../../assets/images/tab_01.png"
import axios from 'axios';
import Top from '../Top';
import EventBusyIcon from '@mui/icons-material/EventBusy';

const ReservationBeforeView = () => {
  const navigate = useNavigate();

  const [reservationSelfList, setReservationSelfList] = useState([]);
  let shownYears = new Set();

  useEffect(() => {
    getReservationList();
  }, []);

  function getReservationList() {

    // 예약 현황 목록 (접속자/접속자 가족 전부)
    api.post('customer/api/v1/CU_004_001', { cusId: window.localStorage.userCusID }).then((res: any) => {
      // let currentYear = new Date().getFullYear();
      let tempSelfList: any = [];
      // const reservationData = res.data.inspection;
      
      // // 본인만
      // for (let i = 0; i < res.data.length; i++) {
      //   if (reservationData[i].ipDate !== null) {
      //     if (reservationData[i].reservationStatus.code >= 11 && parseInt((reservationData[i].ipDate).substring(0, 4)) !== currentYear) {
      //       tempSelfList.push(reservationData[i]);
      //     }
      //   }
      // }

      const nowYear = new Date().getFullYear();
      const reservationData = res.data.inspection.concat(res.data.counsel);
      tempSelfList = reservationData.filter((v: any) => v.famGrade == '본인' && v.reservationStatus.code >= 0 && v.year !== nowYear);

      // 연도 순으로 내림차순
      let result = tempSelfList.sort((a: any, b: any) => {
        if (a.firstWishDate < b.firstWishDate) return 1;
        if (a.firstWishDate > b.firstWishDate) return -1;
        return 0;
      });

      setReservationSelfList(result);

    }).catch(function (error: any) {
      console.log(error)
    })
  }

  return (

    <Container sx={{ bgcolor: '#F6F6F6', minHeight: '100vh', p: 0, pt: 7, pb: 12, minWidth: 320 }}>
      <Top title='검진 기록 확인' />

      {/* <Box sx={{ bgcolor: '#FFFBF8' }}>
        <Typography sx={{ display: 'block', fontSize: '14px', color: '#444', fontWeight: 700, p: 0, pt: 3, pb: 0.5, textAlign: 'center' }}>
          예약일이 확정되면 취소가 되지 않습니다.
        </Typography>
        <Typography sx={{ display: 'block', fontSize: '14px', color: '#EF8322', fontWeight: 700, p: 0, pb: 3, textAlign: 'center' }}>
          확정 후 예약취소는 담당자에게 문의해 주세요.
        </Typography>
      </Box> */}

      {
        reservationSelfList.length <= 0
          ? <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 10, }}>
            <EventBusyIcon sx={{ fontSize: 50, color: '#bbb' }} />
            <Typography sx={{ fontSize: 16, color: '#888' }} >검진 기록이 없습니다.</Typography>
          </Stack>
          : reservationSelfList.map((reservation: any, index: any) => {
            const year = reservation.firstWishDate.substr(0, 4);
            const isFirst = !shownYears.has(year);

            if (isFirst) {
              shownYears.add(year);
            }

            return (
              <React.Fragment>
                {
                  isFirst && (
                    <Divider component="div" sx={{ mt: 5, mb: 3, fontSize: 14, color: '#777', width: '80%', ml: 'auto', mr: 'auto' }}><Chip label={year} sx={{ width: 90 }} /></Divider>
                  )
                }
                <Box sx={{ p: 2, bgcolor: '#fff', my: 2 }}>

                  {reservation.reservationStatus.code === -10 ? (
                    <Box sx={{ bgcolor: '#8949496b', mb: 2, position: 'absolute', left: 0, width: '100%', height: '280px' }}>
                      <Typography sx={{
                        fontSize: 30,
                        fontWeight: 700,
                        color: '#fff',
                        transform: 'rotateZ(30deg)',
                        textAlign: 'center',
                        top: '40%',
                        position: 'relative',
                        border: '6px double #fff',
                      }}>
                        예약 취소</Typography>
                    </Box>
                  ) : (
                    null
                  )}

                  <Stack direction="row" alignItems={'center'} spacing={0} sx={{ p: 0 }}>
                    <Typography sx={{ fontSize: 16, ml: 1 }}>{util.strNull(reservation.ipDate) !== '' ? reservation.ipDate : reservation.firstWishDate}
                      <Typography component={'span'} sx={{ fontSize: 12, color: '#777', ml: 1 }}>{util.strNull(reservation.ipDate) !== '' ? '예약 확정일' : '예약 희망일'}</Typography> </Typography>
                    <Button sx={{ fontSize: 12, ml: 'auto', p: 0, verticalAlign: 'baseline', color: '#888' }}
                      onClick={() => { navigate('../reservation/SetFinishDetail', { state: { hoImage: reservation.hoImage, rsvId: reservation.rsvId, url: 'ReservationBeforeView' } }) }}>
                      상세보기 <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#999' }} />
                    </Button>
                  </Stack>

                  <Card sx={{ borderRadius: 3, mt: 1, }}>
                    <Stack direction={'row'} spacing={0} sx={{ p: 2, pt: 2, pb: 1 }}>
                      <Typography sx={{ fontSize: 16, fontWeight: 700, mr: .5 }}>
                        {reservation.famName}
                      </Typography>
                      <Typography sx={{ fontSize: 14, }}>
                        {`(${reservation.famGrade})`}
                      </Typography>
                    </Stack>

                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} sx={{ p: 2, pt: 0, pb: 1 }}>
                      <Box sx={{ width: 100, height: 80, display: 'flex', border: '1px solid #eee' }}>
                        <Img alt="care" src={util.strNull(reservation.hoImage) !== '' ? reservation.hoImage : img01} />
                      </Box>
                      <Stack direction="column" justifyContent="center" spacing={0} sx={{ width: '65%' }}>
                        <Typography sx={{ fontSize: 14, fontWeight: 700 }}>
                          {reservation.hoName}
                        </Typography>
                        <Typography sx={{ fontSize: 12, mt: 0.3, mb: 0.5 }}>
                          {reservation.hoAddress + reservation.hoBuildingNum}
                        </Typography>
                        <Typography sx={{ fontSize: 14, fontWeight: 700, }}>
                          {reservation.firstWishDate} {reservation.reservationTime == 0 ? null : `${String(reservation.reservationTime).slice(0, -2)}:${String(reservation.reservationTime).slice(-2)}`}
                          <Chip label="검진완료" size="small" sx={{ ml: 1, verticalAlign: 'top', bgcolor: '#444', color: '#cccccc' }}></Chip>
                        </Typography>
                      </Stack>
                    </Stack>

                    {/* <Divider orientation="vertical" flexItem /> */}

                    <Stack direction="column" spacing={0} sx={{ p: 2, pt: 0 }}>
                      <Typography sx={{ fontSize: 14, fontWeight: 700, mb: 0.5 }}>
                        {reservation.rsvName}
                      </Typography>
                      <Typography sx={{ fontSize: 14, wordBreak: 'keep-all' }}>
                        {reservation.ipiList.join(', ')}
                      </Typography>
                    </Stack>

                    <Divider />




                  </Card>

                </Box>
              </React.Fragment>
            )
        })
      }

      <Bottom />
    </Container>
    // <Container className='container'>
    //   <Box sx={img} >
    //     <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
    //       <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
    //         <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900, }}>
    //           예약서비스
    //         </Typography>
    //         <Typography sx={{ fontSize: '1.8rem', color: '#1cb10b', fontWeight: 500, }} gutterBottom>
    //           검진기록
    //         </Typography>
    //       </Grid>
    //     </Grid>
    //   </Box>


    //   

    //   {/* 무한 스크롤 */}
    //   {/* <Box>
    //     <List sx={{ width: '100%', m: '10px auto' }}>
    //       <InfiniteScroll
    //         pageStart={0}
    //         // ref={isRef}
    //         loadMore={getReservationList}
    //         hasMore={true}
    //         loader={
    //           <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center' }} justifyContent='center' alignContent={'center'}>
    //             <CircularProgress />
    //           </Box>
    //         }
    //       >

    //       </InfiniteScroll>
    //     </List>
    //   </Box> */}

    //   <Bottom />
    // </Container >
  );
}

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const img = {
  display: 'flex', p: 0, backgroundImage: `url('')`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}

export default ReservationBeforeView;